import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import { useTranslation } from "react-i18next";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { getImportOrderStateData } from "../../../../utils/labelColorText";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";

const OrderLogsCard = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const stateData = props.skeleton ? {labelcolor: "grey", labeltext : ""} : getImportOrderStateData(props.state, theme);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick} >
            <Box>
                <Box>
                    <Box 
                        display={"flex"} 
                        flexDirection={"column"} 
                        gap={props.skeleton ? 0.5 : null} 
                        width={props.skeleton ? "58%" : null}
                    >
                        {props.skeleton ?
                            <ShTextSkeleton/>
                            :
                            <>
                                <Text>{props.webshopreference}</Text>
                                <Text light>{props.webshopCredentials?.description}</Text>
                            </>
                        }
                    </Box>
                    <TopRight>
                        <CardLabel 
                            variant={stateData.labelcolor}
                            // variant={"grey"}  
                            // background={theme.palette.mode === "dark" ? colors.grey[400] : null} 
                            // color={theme.palette.mode === "dark" ? colors.txt["primary"] : null} 
                            position="child-tr"
                        >
                            {t(stateData.labeltext)}
                        </CardLabel>
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3}>
                        <Box display={"flex"} flexDirection={"column"}>

                            {props.skeleton ?
                                <ShDoubleTextSkeleton />
                                :
                                <>
                                    <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{props.order.barcode}</Text>

                                    <Text>
                                        {props.message && props.message.length > 0 ? props.message : props.errorMessage}    
                                    </Text>
                                </>
                            }
                        </Box>
                        {/* <Box display={"flex"} flexDirection={"column"}>
                            <Text light>{t("updated_at")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Text>
                                    {new Date(props.updatedAt).toLocaleString(i18n.language, {
                                        dateStyle: 'short',
                                        timeStyle: 'short'
                                    })}
                                </Text>
                            }
                        </Box> */}
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default OrderLogsCard;